import React from "react";
import "./Matress_Description.css";

const matressData = [
  {
    title: "3D Ventilated Fabric",
    description:
      "3D Ventilated fabric is a textile that results from knitting,the process of inter-looping of yarns or inter-meshing of loops. Its properties are distinct from woven fabric in that it is more flexible & can be more readily constructed into smaller pieces, making it ideal for socks and hats.",
    image: "/assets/images/hospitality/fabric_foam.png",
  },
  {
    title: "Polyfil",
    description:
      "Polyfill, or polyester fiberfill, is a petroleum-based, nonrenewable resource that is energy intensive and contains toxic chemicals. Because polyester is cheap and versatile, it's become a popular option for a variety of uses, including crafting.",
    image: "/assets/images/hospitality/polyfill_foam.png",
  },
  {
    title: "Soft Foam (3 / 4 / 10)",
    description:
      "These are polyether based Polyurethane foam made with extra softness for specific comfort applications. Soft foams are available in low to medium density range (15-30 kg/m3). soft foams are used for all quilting needs, mattress overlay, top lining in sofas, pillows etc.",
    image: "/assets/images/hospitality/soft_foam.png",
  },

  {
    title: "Comfort Foam",
    description:
      "Comfort Foam is made with Aero Sleep technology that promotes ample airflow and gives great support to the body..",
    image: "/assets/images/hospitality/comfortfoam.png",
  },
  {
    title: "Non-Woven",
    description:
      "Non-woven fabrics are broadly defined as sheet or web structures bonded together by entangling fiber or filaments (and by perforating films) mechanically, thermally, or chemically. They are flat, porous sheets that are made directly from separate fibers or from molten plastic or plastic film.",
    image: "/assets/images/hospitality/non-woven.png",
  },

  {
    title: "Thermobond Felt (7 / 9)",
    description:
      "NOur Turkish Felt is produced by matting, condensing, & pressing fibers together providing reinforced and firmer support to the mattress.",
    image: "/assets/images/hospitality/thermobond-belt.png",
  },

  {
    title: "Pocket Springs",
    description:
      "Pocket spring mattresses are often recommended for orthopedic patients with hip and shoulder problems. Pocket spring mattresses have each individual spring acts to support your entire body, making it near-impossible for individual areas, like your hips & shoulders, to have too much pressure when sleeping. Fitted with a luxurious upper layer of foams that makes mattress soft to the touch and even more comfortable to sleep on at night.",
    image: "/assets/images/hospitality/pocket_spring.png",
  },

  {
    title: "Anti-Skid Fabric",
    description:
      "Springfit Absolute Bliss Mattress comes with organic anti-skid fabric, which reduces movement of the mattress. Not only this, but the fabric is highly breathable and helps in reducing moisture trapped inside the mattress.",
    image: "/assets/images/hospitality/skid.png",
  },
];

const Matress_Description = () => {
  return (
    <section className="matress_section">
      <div className="container">
        {matressData.map((item, index) => (
          <div
            key={index}
            className={`matress_box ${
              index % 2 === 0 ? "bg_grey" : "bg_white"
            }`}
          >
            <div className="matress_inner">
              {/* Title First */}
              <h3 className="matress_title">{item.title}</h3>

              <div className="matress_row">
                <div className="matress_img_div">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="matress_img"
                  />
                </div>

                <div className="matress_content_div">
                  <p className="matress_description">{item.description}</p>
                </div>

          
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Matress_Description;
